import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React from 'react';
const MenuDivider = ({ className, ...other })=>/*#__PURE__*/ React.createElement("hr", {
        className: cx(className),
        ...other
    });
MenuDivider.propTypes = {
    /**
	 * Custom `className` for the root.
	 */ className: PropTypes.string
};
MenuDivider.displayName = 'MenuDivider';
export default MenuDivider;
